<template>
  <div class="filters-container">
    <legend-list />
    <locations-filter-view :store="filtersStore" />
  </div>
</template>

<script>
import { useCalibrationFiltersStore } from "@/stores/calibration";
import LegendList from "@/components/filters/LegendList.vue";
import LocationsFilterView from "@/components/filters/LocationsFilterView.vue";

export default {
  name: "FilterCalibrationData",
  components: {
    LegendList,
    LocationsFilterView,
  },
  setup() {
    const filtersStore = useCalibrationFiltersStore();
    return { filtersStore };
  },
};
</script>

<style scoped>
.filters-container {
  width: 100%;
}
</style>
